//@flow
import {
	ADD_TASK_POSITION,
	ADD_TASKS_WITH_SPARES,
	CONSUME_WATCHLIST,
	IMPORT_INSPECTION_LIST,
	REMOVE_SPARE_POSITION,
	REMOVE_TASK_POSITION,
	UPDATE_SPARE_POSITION,
	UPDATE_TASK_POSITION
} from "../proposal/action";
import type {SparePositionType, TaskPositionType} from "../proposal/model";
import {
	addPartsToOrder,
	addTasksToOrder,
	addTasksWithParts,
	addWatchListItemsToOrder,
	deletePartFromOrder,
	deleteTaskFromOrder,
	updatePartFromOrder,
	updateTaskFromOrder
} from "../dms/action";
import Configuration from "../Configuration";

export const dmsOrderMiddleware = store => next => action => {
	const proposalHasNoLinkedDmsOrder = !store.getState().proposal.current?.dmsOrderNumber;
	if (proposalHasNoLinkedDmsOrder) {
		return next(action);
	}

	if (Configuration.isUnlockedForBetaFeature(action.dealerNumber)) {
		switch (action.type) {
			case ADD_TASKS_WITH_SPARES.SUCCESS:
				store.dispatch(
					addTasksWithParts(
						store.getState().proposal.current.dmsOrderNumber,
						action.tasks.map((task: TaskPositionType) => {
							return {
								taskNumber: task.operationNumber,
								description: task.name,
								workTime: task.workingHours
							};
						}),
						action.spares.map((spare: SparePositionType) => {
							return {
								partNumber: spare.productNumber,
								quantity: spare.amount,
								unitPriceValue: spare.retailPrice
							};
						}),
						action.lineItemId
					)
				);
				break;
			case CONSUME_WATCHLIST.SUCCESS:
				store.dispatch(
					addWatchListItemsToOrder(
						store.getState().proposal.current.dmsOrderNumber,
						action.watchListName,
						action.lineItemId
					)
				);
				break;
			case UPDATE_SPARE_POSITION.SUCCESS:
				store.dispatch(
					updatePartFromOrder(
						store.getState().proposal.current.dmsOrderNumber,
						action.partNumber,
						action.quantity,
						action.unitPriceNetValue,
						action.lineItemId
					)
				);
				break;
			case REMOVE_SPARE_POSITION.SUCCESS:
				store.dispatch(
					deletePartFromOrder(
						store.getState().proposal.current.dmsOrderNumber,
						action.partNumber,
						action.lineItemId
					)
				);
				break;
			case ADD_TASK_POSITION.SUCCESS:
				store.dispatch(
					addTasksToOrder(
						store.getState().proposal.current.dmsOrderNumber,
						action.tasks.map((task: TaskPositionType) => {
							return {
								taskNumber: task.operationNumber,
								description: task.name,
								workTime: task.workingHours
							};
						}),
						action.lineItemId
					)
				);
				break;
			case REMOVE_TASK_POSITION.SUCCESS:
				store.dispatch(
					deleteTaskFromOrder(
						store.getState().proposal.current.dmsOrderNumber,
						action.taskNumber,
						action.lineItemId
					)
				);
				break;
			case UPDATE_TASK_POSITION.SUCCESS:
				store.dispatch(
					updateTaskFromOrder(
						store.getState().proposal.current.dmsOrderNumber,
						{
							taskNumber: action.task.operationNumber,
							description: action.task.name,
							workTime: action.task.workingHours
						},
						action.lineItemId
					)
				);
				break;
			case IMPORT_INSPECTION_LIST.SUCCESS:
				store.dispatch(
					addTasksToOrder(
						store.getState().proposal.current.dmsOrderNumber,
						action.lineItems.map((task: TaskPositionType) => {
							return {
								taskNumber: task.operationNumber,
								description: task.name,
								workTime: task.workingHours
							};
						})
					)
				);
				store.dispatch(
					addPartsToOrder(
						store.getState().proposal.current.dmsOrderNumber,
						action.spares.map((spare: SparePositionType) => {
							return {
								partNumber: spare.productNumber,
								quantity: spare.amount,
								unitPriceValue: spare.retailPrice
							};
						})
					)
				);
				break;
			default:
				break;
		}
	}
	return next(action);
};
